import { BaseService, Service } from "/@/cool";
@Service("completeOrders")
class completeOrders extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["details"] = prefix + "details";
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
	}

	details(params: any) {
		return this.request({
			url: "/details",
			method: "get",
			params
		});
	}
}
export default completeOrders;
